<template lang="pug">
  #pointsCard
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 集點卡
    .container-width
      .pb-4.pt-3.px-2
        div.text-center(
          v-if="!activityList || activityList.length === 0"
        ) 無集點活動
        b-card.m-3.border-black.custom-shadow(
          bg-variant="light",
          v-for="(item, index) in activityList",
          :key="item.point_collection_id"
          body-class="d-flex flex-wrap align-items-center justify-content-between"
        )
          h6.mb-1(@click="$router.push({ name: 'sa-missions-list',params: { activityId: item.point_collection_id, activityName:  item.point_collection_name}})") {{ item.point_collection_name }}
          //- h6.mb-1 活動區間：{{ item.stime }} ~ {{ item.etime }}
          div.flex-grow-1.text-right
            b-button.btn-sm(v-b-modal.member-points-demo-modal, variant="remind", @click="memberPointsDemoImageUrl = item.demo_image_url") 集點卡 Demo 頁面
    b-modal#member-points-demo-modal(
      centered,
      scrollable,
      title="集點卡 Demo"
      header-class="p-2"
      body-class="p-0"
      hide-footer,
    )
      div(v-if="!memberPointsDemoImageUrl") 無圖片
      div(v-else)
        img(:src="memberPointsDemoImageUrl", alt="")
</template>

<script>
  import { mapState } from 'vuex';

  export default {
  name: 'pointsCardIndex',
  components: {
  },
  data() {
    return {
      memberPointsDemoImageUrl: "",
    };
  },
  mounted() {
    const vm = this;
    vm.initHandler();
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_points_card/getActivityHandler')
        .then(() => {
          vm.$swal.close();
        });
    },
  },
  computed: {
    ...mapState({
      activityList: (state) => state.sa_points_card.activityList,
    })
  }
};
</script>

<style scoped>
  img {
    max-width: 100% !important;
    height: auto;
  }
  .card-body {
    padding: 16px;
  }
  .border-black {
    border: 0.2rem solid #000;
    border-radius: 15px;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
  }

  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  #header_back {
    font-size: 1.7rem;
    padding: 0.5rem;
    position: absolute;
    top: 3%;
    left: 1.6rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: #fff !important;
    z-index: 15;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-icon_arrowLeft {
    top: 0;
    left: 5px;
  }
  .icon-icon_arrowLeft:before {
    content: "\e907";
  }

  .icon-icon_location:before {
    content: "\e909";
  }
</style>
